module.exports = __webpack_public_path__ + "static/img/write_note.d0eae0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/write_note.png
// module id = CAXl
// module chunks = 1